import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App.jsx'
import { init, browserTracingIntegration } from "@sentry/react";
import config from './constants/global.js';

init({
  dsn: config.sentryDsn,
  sendDefaultPii: true,
  environment: config.environment,
  release: `sokooni@${config.version}`,
  integrations: [
    browserTracingIntegration()
  ],
  tracesSampleRate: 0.4,
  tracePropagationTargets: ["localhost", /^https:\/\/eastsoko-api\.rtilab\.dev\/api/]
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
